import React, { useEffect } from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import HomeIcon from '@mui/icons-material/Home';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';

import { Outlet, useNavigate } from "react-router-dom";

const drawerWidth = 240;

export default function App(props) {
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const navigate = useNavigate()

  useEffect(() => {
  }, []);

  const drawer = (
    <div>
      <Toolbar />
      <Divider />
      <List>
        <ListItem key="sortingTable" disablePadding>
          <ListItemButton>
            <ListItemText primary="可排序 Table" onClick={() => {
              navigate('/sortingTable');
            }} />
          </ListItemButton>
        </ListItem>
        <ListItem key="dropZone" disablePadding>
          <ListItemButton>
            <ListItemText primary="拖曳上傳檔案" onClick={() => {
              navigate('/dropZone');
            }} />
          </ListItemButton>
        </ListItem>
        <ListItem key="copyToClipboard" disablePadding>
          <ListItemButton>
            <ListItemText primary="複製到剪貼簿" onClick={() => {
              navigate('/copyToClipboard');
            }} />
          </ListItemButton>
        </ListItem>
        <ListItem key="wheel" disablePadding>
          <ListItemButton>
            <ListItemText primary="轉盤" onClick={() => {
              navigate('/wheel');
            }} />
          </ListItemButton>
        </ListItem>
      </List>
    </div>
  );

  const container = window !== undefined ? () => window().document.body : undefined;

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          ml: { sm: `${drawerWidth}px` },
        }}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1 }} style={{ cursor: 'pointer' }} onClick={() => {
            navigate('/');
          }}>
            <HomeIcon /> 固巧快 MUI Component 測試 & Demo
          </Typography>
        </Toolbar>
      </AppBar>
      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="mailbox folders"
      >
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: 'none', sm: 'block' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>
      <Box
        component="main"
        sx={{ flexGrow: 1, p: 3, width: { sm: `calc(100% - ${drawerWidth}px)` } }}
      >
        <Toolbar />
        <Typography paragraph component={'div'}>
          <Outlet />
        </Typography>
      </Box>
    </Box>
  );
}
